import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserDataService {
  readonly buildingId = signal<string | null>(null);
  readonly siteAdmin  = signal<boolean>(false);
  readonly isOrg      = signal<boolean>(false);

  constructor() {
    const platformId = inject(PLATFORM_ID);
    if (isPlatformBrowser(platformId)) {
      const savedId    = localStorage.getItem('lockdown_building_id');
      const savedAdmin = localStorage.getItem('lockdown_site_admin');
      const savedIsOrg = localStorage.getItem('lockdown_is_org');
      if (savedId)    this.buildingId.set(savedId);
      if (savedAdmin) this.siteAdmin.set(savedAdmin === 'true');
      if (savedIsOrg) this.isOrg.set(savedIsOrg === 'true');
    }
  }
}
